import { createContext } from "react";


class SpeakersStore {
  columnVisibility = {}
  columnFilters = []
  globalFilter = undefined
  searchField = 'fullName'
  pagination = { pageIndex: 0, pageSize: 10 }
  // State preservation fields
  tableData = []
  isLoading = true
  isRefetching = false
  open = false
  scrollTop = 0
  needsRefresh = false
}


export const speakersStore = new SpeakersStore()
export const SpeakersStoreContext = createContext(speakersStore)
